var render = function render(_c,_vm){return _c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.OpenSelect(_vm.props)}}},[_vm._v(_vm._s(_vm.props.row[_vm.props.column]))])
}
var staticRenderFns = []

export { render, staticRenderFns }